var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWhatsappMobile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.748,
    y: 0.423,
    width: 32.185,
    height: 32.185,
    rx: 16.093,
    fill: "#6B47F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.926 17.857c-.134-.067-1.005-.47-1.14-.537-.134-.067-.268-.067-.402.068-.134.134-.402.536-.536.67-.067.134-.201.134-.336.067a5.48 5.48 0 0 1-1.34-.805 7.708 7.708 0 0 1-.94-1.14c-.066-.133 0-.268.068-.335.067-.067.134-.2.268-.268a.508.508 0 0 0 .134-.268.204.204 0 0 0 0-.268c-.067-.067-.402-.872-.536-1.207-.067-.47-.202-.47-.336-.47h-.335c-.134 0-.335.135-.402.202-.402.402-.604.871-.604 1.408.067.603.268 1.207.67 1.743.738 1.073 1.677 1.945 2.817 2.481.335.134.604.268.939.335.335.134.67.134 1.073.067.469-.067.871-.402 1.14-.804.134-.268.134-.537.067-.805l-.269-.134zm1.677-6.102a6.677 6.677 0 0 0-9.455 0c-2.145 2.146-2.548 5.431-1.073 8.046l-.938 3.42 3.553-.939a6.674 6.674 0 0 0 3.152.805 6.61 6.61 0 0 0 6.638-6.638c.067-1.744-.67-3.42-1.877-4.694zm-1.81 9.387c-.872.537-1.878.872-2.951.872-1.006 0-1.945-.268-2.816-.737l-.201-.135-2.079.537.536-2.012-.134-.2c-1.609-2.683-.804-6.035 1.81-7.712 2.616-1.676 5.968-.804 7.577 1.744 1.61 2.615.872 6.034-1.743 7.643z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsappMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsapp_mobile.dfa97de0.svg";
export { ForwardRef as ReactComponent };